import React from 'react';
import styles from './DownloadRiselio.module.scss';

export function DownloadRiselio() {
    return (
        <div className={styles.Wrapper}>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-xl-6">
                        <h2>Bergabung Bersama Platform Reseller terpercaya di Indonesia</h2>
                        <p>Download Aplikasi Riselio dan mulai dapatkan penghasilan dari rumah sekarang juga!</p>
                        <p><b>GRATIS</b> VIP selama 15 hari!</p>
                        <br />
                        <a href="https://play.google.com/store/apps/details?id=com.application.riselio" target="_blank" rel="noopener noreferrer">
                            <img alt="google-play.png" className="btn-google-play undragable" src="./assets/google-play.png" />
                        </a>
                    </div>
                    <div className="col-md-6 col-xl-6">
                        <img alt="app.png" className={styles.Screenshoot__image} src="./assets/screenshoot-app.png" />
                    </div>
                </div>
            </div>
        </div>
    );
}

